'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Card } from '@repo/ui/components'
import { WalletCards } from './wallet.cards'
import type { Asset } from './wallet.types'
import { useUserPortfolio } from '@repo/services'
import { WalletProjectCards } from './wallet-project.cards'
export const WalletSimpleContainer = () => {
  const { t } = useTranslate()

  const {
    data: { data: { accounts = [], projects = [] } = {} } = {},
    isLoading: isLoadingPortfolio,
  } = useUserPortfolio()

  const wallets: Asset[] = (accounts || [])
    .filter((account) => account.type !== 'project')
    .map((account, index) => ({
      id: `${'account'}-${index}`,
      title:
        account.type === 'fiat' && account.currency === 'IRR'
          ? t('walletPage_toman_balance')
          : account.type === 'asset' && account.currency === 'MALEK'
            ? t('walletPage_malek_balance')
            : (account.currency ?? ''),
      amount: account.estimatedBalance ?? 0,
      assetAmount: account.availableBalance ?? 0,
      unit: account.currency ?? '',
      icon:
        account.type === 'fiat' && account.currency === 'IRR'
          ? 'Tmn'
          : undefined,
      type: account.type,
      href:
        account.type === 'asset' && account.currency === 'MALEK'
          ? `/history/balance/asset/${account.currency}`
          : `/history/balance`,
    }))

  const userProjects = (accounts || []).filter(
    (account) => account.type === 'project',
  )

  const sortedWallets = wallets.sort((a, b) => {
    if (a.type === 'fiat' && b.type === 'asset') return -1
    if (a.type === 'asset' && b.type === 'fiat') return 1
    return 0
  })

  const filteredProjects = projects.filter(
    (project) => project.state === 'other',
  ) // TODO: remove condition exchange

  return (
    <div className='flex flex-col md:flex-row max-w-container-md mx-auto gap-md'>
      <Card withoutBorder className='w-full mb-9xl md:mb-0 p-md'>
        <WalletCards wallets={sortedWallets} isLoading={isLoadingPortfolio} />
        <WalletProjectCards
          projects={filteredProjects || []}
          userProjects={userProjects}
          isLoading={isLoadingPortfolio}
        />
      </Card>
    </div>
  )
}
